/** Origens da atividade*/
export interface AtividadeOrigem {
    id: number;
    nome: string;
}

export const origemAtividade: AtividadeOrigem = {id: 1, nome: 'Atividade'};
export const origemFunilVenda: AtividadeOrigem = {id: 2, nome: 'Funil de Vendas'};
export const origemClienteCarteira: AtividadeOrigem = {id: 3, nome: 'Carteira de Clientes'};
export const origemTituloReceber: AtividadeOrigem = {id: 4, nome: 'Título a Receber'};
export const origemCadastroCliente: AtividadeOrigem = {id: 5, nome: 'Cadastro de Cliente'};
export const origemNegocio: AtividadeOrigem = {id: 6, nome: 'Negócio'};
export const origemRetorno: AtividadeOrigem = {id: 7, nome: 'Retorno'};

export const atividadeOrigems: AtividadeOrigem[] = [
    origemAtividade,
    origemFunilVenda,
    origemClienteCarteira,
    origemTituloReceber,
    origemCadastroCliente,
    origemNegocio,
    origemRetorno
];


/** Verifica se a origem da atividade é a atividade */
export function isOrigemAtividade(id: number): boolean {
    return id === origemAtividade.id;
}

/** Verifica se a origem da atividade é o funil de vendas */
export function isOrigemFunilVenda(id: number): boolean {
    return id === origemFunilVenda.id;
}

/** Verifica se a origem da atividade é a carteira de clientes */
export function isOrigemClienteCarteira(id: number): boolean {
    return id === origemClienteCarteira.id;
}

/** Verifica se a origem da atividade é título a receber */
export function isOrigemTituloReceber(id: number): boolean {
    return id === origemTituloReceber.id;
}


/** Verifica se a origem da atividade é cadastro de cliente */
export function isOrigemCadastroCliente(id: number): boolean {
    return id === origemCadastroCliente.id;
}

/** Verifica se a origem da atividade é negócio */
export function isOrigemNegocio(id: number): boolean {
    return id === origemNegocio.id;
}

/** Verifica se a origem da atividade é retorno */
export function isOrigemRetorno(id: number): boolean {
    return id === origemRetorno.id;
}
